var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrainingAndDocs = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 3.75C1.5 3.33579 1.83579 3 2.25 3H8C9.25978 3 10.468 3.50044 11.3588 4.39124C12.2496 5.28204 12.75 6.49022 12.75 7.75V21.75C12.75 22.1642 12.4142 22.5 12 22.5C11.5858 22.5 11.25 22.1642 11.25 21.75C11.25 21.1533 11.013 20.581 10.591 20.159C10.169 19.7371 9.59674 19.5 9 19.5H2.25C1.83579 19.5 1.5 19.1642 1.5 18.75V3.75ZM11.25 18.75V7.75C11.25 6.88805 10.9076 6.0614 10.2981 5.4519C9.68861 4.84241 8.86196 4.5 8 4.5H3V18H9C9.81607 18 10.6047 18.266 11.25 18.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6412 4.39124C13.532 3.50044 14.7402 3 16 3H21.75C22.1642 3 22.5 3.33579 22.5 3.75V18.75C22.5 19.1642 22.1642 19.5 21.75 19.5H15C14.4033 19.5 13.831 19.7371 13.409 20.159C12.9871 20.581 12.75 21.1533 12.75 21.75C12.75 22.1642 12.4142 22.5 12 22.5C11.5858 22.5 11.25 22.1642 11.25 21.75V7.75C11.25 6.49022 11.7504 5.28204 12.6412 4.39124ZM12.75 18.75C13.3953 18.266 14.1839 18 15 18H21V4.5H16C15.138 4.5 14.3114 4.84241 13.7019 5.4519C13.0924 6.0614 12.75 6.88805 12.75 7.75L12.75 18.75Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrainingAndDocs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/training-and-docs.42bcc45d26cce4095db249ff0df6f1f6.svg";